import { useTheme, styled } from '@mui/material';
import React from 'react';
import { WBContainer, WBFlex } from '@admiin-com/ds-web';
import { TaskCreateModalProps } from './type';
import TaskCreateHeader from './components/Header';
import { Content } from './components/Content';
const StyledWBFlex = styled(WBFlex)(({ theme }) => ({
  flexDirection: 'column',
  flex: 1,
  alignItems: 'center',
  height: '100%',
  backgroundColor: theme.palette.background.default,
}));

export function TaskCreateModalMobile({
  onClose,
  page,
  setPage,
  open,
  isEditing,
  onSignatureCreated,
  taskDirection,
  createdTask,
  binding,
  taskType,
  isBinding,
  taskProps,
}: TaskCreateModalProps) {
  const theme = useTheme();
  return (
    open && (
      <WBFlex
        position="fixed"
        top={0}
        left={0}
        right={0}
        role="dialog"
        bottom={0}
        overflow={'auto'}
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          bgcolor: theme.palette.background.default,
        }}
        width={'100%'}
      >
        <StyledWBFlex>
          <TaskCreateHeader
            open={open}
            onClose={onClose}
            isEditing={isEditing}
            setPage={setPage}
            page={page}
            taskType={taskType}
            isBinding={isBinding}
            taskProps={taskProps}
          />
          <ContentContainer
            // maxWidth="xl"
            sx={{
              height: '100%',
              width: '100%',
              px: [1, 2],
              py: [1, 3],
              borderTop: `1px solid ${theme.palette.divider}`,
              bgcolor: theme.palette.background.default,
            }}
          >
            <Content
              page={page}
              setPage={setPage}
              open={open}
              isEditing={isEditing}
              onSignatureCreated={onSignatureCreated}
              taskDirection={taskDirection}
              createdTask={createdTask}
              onClose={onClose}
              taskType={taskType}
              isBinding={isBinding}
              binding={binding}
            />
          </ContentContainer>
        </StyledWBFlex>
      </WBFlex>
    )
  );
}
const ContentContainer = styled(WBContainer)(({ theme }) => ({
  [theme.breakpoints.down('sm')]: {
    padding: theme.spacing(0),
  },
}));
export default TaskCreateModalMobile;
